import { z } from 'zod'

import {
  type FunnelCheck,
  FunnelEntryType,
} from '@/modules/tracking/funnel/types.ts'

export interface FormValues {
  entryPointType: FunnelEntryType
  entryPointData: string
  goesThroughInstagram: boolean
  goalUrl: string
}

export const funnelTrackingFormSchema = z.object({
  entryPointType: z.nativeEnum(FunnelEntryType),
  entryPointData: z.string().min(1, 'This field is required'),
  goalUrl: z.string().min(1, 'This field is required'),
  goesThroughInstagram: z.boolean(),
})

export const getInitialValues = (
  creatorName: string | null,
  item?: FunnelCheck | null,
): FormValues => ({
  entryPointType: item?.entryPointType || FunnelEntryType.Instagram,
  entryPointData: item?.entryPointData || '',
  goesThroughInstagram: item?.goesThroughInstagram ?? true,
  goalUrl:
    item?.goalUrl || `https://onlyfans.com/${creatorName?.toLowerCase()}`,
})
